export default __webpack_public_path__ + "static/media/kingsfund.21c1cca9.png";